import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { zip } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/service/auth.service';

@Component({
  selector: 'app-admin-details',
  templateUrl: './admin-details.component.html',
  styleUrls: ['./admin-details.component.scss'],
})
export class AdminDetailsComponent implements OnInit {
  displayedColumns: string[] = [
    'Company Name',
    'Entrepreneur First name',
    'Entrepreneur Last name',
    'AdminCode added Date',
    'AdminCode removed Date',
    'Status',
    'Action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  adminCode: any;
  isSuperAdmin: boolean;
  constructor(
    private dbstore: AngularFirestore,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.adminCode = this.authService.adminCode;
    this.isSuperAdmin = this.authService.isSuperAdmin;
    this.activatedRoute.params
      .pipe(
        map((param) => param),
        switchMap((data) =>
          zip(
            this.dbstore
              .collection('users', (ref) =>
                ref.where('adminCode.value', '==', data?.admincode || null)
              ).valueChanges(),
            this.dbstore.collection('users', (ref) =>
              ref.where('adminCode', '==', data?.admincode || null)
            )
              .valueChanges()
          )
        ),
        map((users: any) => users.flat())
      )
      .subscribe((data: any[]) => {
        this.dataSource = new MatTableDataSource(
          data.filter((el) => el?.uid != this.authService?.userData?.uid)
        );
        this.dataSource.paginator = this.paginator;
        this.cd.detectChanges();
      });
  }

  isString = (value: any): boolean => {
    return typeof value === 'string';
  }

  revokeAdminCode(code: any, businessUID: string) {
    const newAdminCode = {
      ...code,
      disabled: true,
      timestampedremove: Date.now()
    };
    this.dbstore
      .collection('users')
      .doc(businessUID)
      .update({ adminCode: newAdminCode })
      .then(() => {
        this.adminCode = newAdminCode?.value;
        this.authService.adminCode = newAdminCode;
        this.dbstore
        .collection('user-admin-code-removed')
        .doc(businessUID)
        .set({
          adminCode: this.authService.adminCode,
          timestamp: Date.now(),
        });
      });
  }
}
